module.exports = __webpack_public_path__ + "static/ShapeText-c91969bace8b55326bee2ac5e9700879.png";